import { useIsMobile } from "@src/appV2/redesign/AppLayout/useResponsive";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";

import { AuthRedirectViewLegacy } from "./AuthRedirectViewLegacy";
import { AuthRedirectViewRedesigned } from "./AuthRedirectViewRedesigned";
import { EmailInputView } from "./EmailInputView";
import { type AuthState } from "./types";

interface AuthRedirectViewProps {
  authState: AuthState;
  error?: string;
  existingEmail?: string;
  magicLinkEmail?: string | null;
  /** Custom-scheme URL to open the native app. Shown on mobile browsers where Universal Links failed. */
  appSchemeUrl?: string;
  emailInputError?: string;
  onContinue: () => void;
  onSignOutAndContinue: () => void;
  onSubmitEmail: (email: string) => void;
  onGoToDashboard: () => void;
}

export function AuthRedirectView(props: AuthRedirectViewProps) {
  const isRedesignEnabled = useIsRedesignEnabled();
  const isMobileViewport = useIsMobile();

  // Route the verify-email prompt outside the legacy/redesigned switch so
  // neither view has to carry its own copy of the form, props, and case
  // branch. Destructure first so `authState` narrows after the early
  // return and `viewProps` matches the inner views' narrower interfaces.
  const { authState, emailInputError, onSubmitEmail, ...viewProps } = props;

  if (authState === "email-input") {
    return <EmailInputView emailInputError={emailInputError} onSubmitEmail={onSubmitEmail} />;
  }

  if (isMobileViewport || isRedesignEnabled) {
    return <AuthRedirectViewRedesigned {...viewProps} authState={authState} />;
  }

  return <AuthRedirectViewLegacy {...viewProps} authState={authState} />;
}
